import "@dmuy/datepicker/dist/duDatepicker.css";
import duDatepicker from "@dmuy/datepicker";
import { useEffect, useRef, useState } from "react";
import { getRandomId } from "@src/utils/uid";
import styles from "./dateSelect.module.css";
import { useAppContext } from "@src/autoDebit/AppContext";
import Title from "../Title";
import commonStyles from "../common.module.css";

export interface IDateSelectProps extends AutoDebit.IFormField {
  title: TranslateDescriptor;
  dateOption?: {
    minDate?: string;
    maxDate?: string;
    placeholder?: string;
  };
  disabled?: boolean;
}

const DateSelect = ({
  onChange,
  value: controlValue,
  dateOption,
  title,
  disabled,
  errorComponent,
}: IDateSelectProps) => {
  const { locale } = useAppContext();
  const [id] = useState(getRandomId);
  const store = useRef<string>();
  useEffect(() => {
    const eleId = `#${id}`;
    if (!document.querySelector(eleId)) return;
    duDatepicker(eleId, {
      maxDate: dateOption?.maxDate,
      minDate: dateOption?.minDate,
      clearBtn: false,
      format: "yyyy/mm/dd",
      i18n: locale || "ja",
      range: false,
      defaultSelect: dateOption?.maxDate,
      events: {
        dateChanged: (date: { date: string }) => {
          store.current = date.date;
          onChange && onChange(date.date);
        },
      },
    });
  }, [id, onChange, locale, dateOption]);

  useEffect(() => {
    if (controlValue !== store.current) {
      const eleId = `#${id}`;
      duDatepicker(eleId, "setValue", controlValue);
      store.current = controlValue;
    }
  }, [controlValue, id, dateOption]);

  const { placeholder = "yyyy/mm/dd" } = dateOption ?? {};
  return (
    <fieldset page-component="DateSelect" className={commonStyles.wrap}>
      <Title text={title}></Title>
      <div className={commonStyles.action}>
        <input
          className={styles.date}
          disabled={disabled}
          type="text"
          id={id}
          placeholder={placeholder}
        />
        {errorComponent && errorComponent()}
      </div>
    </fieldset>
  );
};

export default DateSelect;
